import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import { api } from '../services/api'

interface UserDTO {
  name: string
  email: string
  role: 'admin' | 'user' | 'viewer' | 'digitizer' | 'manager'
  manager?: boolean
  document?: string
}

type State = {
  user?: UserDTO
}

type Actions = {
  setUser: (user?: UserDTO) => void
  logout: () => void
}

export const useUserStore = create(
  persist<State & Actions>(
    (set) => ({
      user: undefined,
      setUser: (user?: UserDTO) => {
        return set(() => ({
          user,
        }))
      },
      logout: () => {
        delete api.defaults.headers.Authorization
        return set(() => ({
          user: undefined,
        }))
      },
    }),
    {
      name: 'user',
    },
  ),
)
